var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavBarArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 13,
    viewBox: "0 0 6 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.49637C6 6.3006 5.92332 6.11933 5.79553 5.98157L1.03514 0.703021C0.920126 0.572507 0.773161 0.5 0.607027 0.5C0.261979 0.5 -1.90661e-06 0.79728 -1.84282e-06 1.18882C-1.81329e-06 1.37009 0.063896 1.55136 0.178912 1.68187L4.52396 6.49637L0.178914 11.3181C0.0638976 11.4486 -1.44118e-07 11.6154 -1.12223e-07 11.8112C-4.96145e-08 12.1955 0.261981 12.5 0.607029 12.5C0.773163 12.5 0.920128 12.4275 1.03514 12.297L5.79553 7.01843C5.92971 6.86616 6 6.69939 6 6.49637Z",
    fill: "#393E42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBarArrow);
export default __webpack_public_path__ + "static/media/nav-bar-arrow.e5366e808c5d2aa0b22c9ca4f2599f6f.svg";
export { ForwardRef as ReactComponent };